import { render, staticRenderFns } from "./distributionOrder.vue?vue&type=template&id=12dca580&scoped=true"
import script from "./distributionOrder.vue?vue&type=script&lang=js"
export * from "./distributionOrder.vue?vue&type=script&lang=js"
import style0 from "./distributionOrder.vue?vue&type=style&index=0&id=12dca580&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dca580",
  null
  
)

export default component.exports